import { render, staticRenderFns } from "./RsAttachment.vue?vue&type=template&id=73f669c2&scoped=true&"
import script from "./RsAttachment.vue?vue&type=script&lang=js&"
export * from "./RsAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f669c2",
  null
  
)

export default component.exports